<template>
  <div>
    <b-form-group
      :id="$id('moreMenuItemNameFieldset')"
      label-cols="2"
      label="Name"
      label-class="pt-0"
      :label-for="$id('moreMenuItemName')"
      description="The name for this menu item">
      <b-form-input
        :id="$id('moreMenuItemName')"
        :value="name"
        name="name"
        trim
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemURLFieldset')"
      label-cols="2"
      label="URL"
      label-class="pt-0"
      :label-for="$id('moreMenuItemURL')"
      description="The URL that the menu item links to">
      <b-form-input
        :id="$id('moreMenuItemURL')"
        v-model="url"
        name="url"
        trim
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemPhoneFieldset')"
      label-cols="2"
      label="Display on phone?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemPhone')"
      description="Will this item be displayed on phones?">
      <b-form-checkbox
        :id="$id('moreMenuItemPhone')"
        :checked="phone"
        name="phone"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemTabletFieldset')"
      label-cols="2"
      label="Display on tablet?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemTablet')"
      description="Will this item be displayed on tablets?">
      <b-form-checkbox
        :id="$id('moreMenuItemTablet')"
        :checked="tablet"
        name="tablet"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemLiteFieldset')"
      label-cols="2"
      label="Display on lite?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemLite')"
      description="Will this item be displayed on lite versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuItemLite')"
        :checked="lite"
        name="lite"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemPaidFieldset')"
      label-cols="2"
      label="Display on paid?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemPaid')"
      description="Will this item be displayed on paid versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuItemPaid')"
        :checked="paid"
        name="paid"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemIosFieldset')"
      label-cols="2"
      label="Display on iOS?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemIos')"
      description="Will this item be displayed on iOS?">
      <b-form-checkbox
        :id="$id('moreMenuItemIos')"
        :checked="ios"
        name="ios"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemAndroidFieldset')"
      label-cols="2"
      label="Display on Android?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemAndroid')"
      description="Will this item be displayed on Android?">
      <b-form-checkbox
        :id="$id('moreMenuItemAndroid')"
        :checked="android"
        name="android"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemVisibleFieldset')"
      label-cols="2"
      label="Visible?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemVisible')"
      description="Will this item be visible?">
      <b-form-checkbox
        :id="$id('moreMenuItemVisible')"
        :checked="visible"
        name="visible"
        @input.native="emitFieldUpdate($event, true, false)" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemIconFieldset')"
      label-cols="2"
      label="Icon"
      label-class="pt-0"
      :label-for="$id('moreMenuItemIconUpload')"
      description="The URL to the icon attached to the short content">
      <b-input-group>
        <b-form-input
          :id="$id('moreMenuItemIconUpload')"
          v-model="icon"
          name="icon"
          trim
          @input.native="emitFieldUpdate" />
      </b-input-group>
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemAccessibilityTextset')"
      label-cols="2"
      label="Accessibility Text"
      label-class="pt-0"
      :label-for="$id('moreMenuItemAccessibilityText')"
      description="The alternative text for accesibility compliance">
      <b-input-group>
        <b-form-input
          :id="$id('moreMenuItemAccessibilityText')"
          name="accessibilityText"
          trim
          @input.native="emitFieldUpdate" />
      </b-input-group>
    </b-form-group>

    <b-modal
      id="asset-upload"
      ref="assetUploadModal"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        post-action="/api/client-content/v1/files/static/more-menu-item"
        :existing-files="[]"
        :process-image-cuts="true"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
    </b-modal>
  </div>
</template>

<script>
import AssetUpload from '@/components/AssetUpload'

export default {
    name: 'MainMenuItem',
    components: {
        AssetUpload,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        phone: {
            type: Boolean,
            default: false,
        },
        tablet: {
            type: Boolean,
            default: false,
        },
        lite: {
            type: Boolean,
            default: false,
        },
        paid: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        ios: {
            type: Boolean,
            default: false,
        },
        android: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        url: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        accessibilityText: {
            type: String,
            default: null,
        },
    },
    computed: {
      CLOUDINARY_ACCOUNT() {
        return process.env.VUE_APP_CLOUDINARY_ACCOUNT
      },
    },
    methods: {
        onAssetSelect(response) {
            this.$refs.assetUploadModal.hide()

            if (response.url) {
                this.emitFieldUpdate({
                    target: {
                        name: 'imageURL',
                        value: response.url,
                    },
                })
            } else {
                console.warn('Ignoring invalid asset selection')
            }
        },
        emitFieldUpdate(event, truthy, falsy) {
            const value = (() => {
              if (event.target.type === 'checkbox') {
                return event.target.checked ? truthy : falsy
              }

              return event.target.value
            })()

            this.$emit("field-update", {
                id: this.id,
                field: event.target.name,
                value,
            })
        },
    },
}
</script>
